import React, { useState } from 'react';
import './StudentSwitcher.css';
import {
    Flex,
    Select,
    Text,
    Box
} from '@radix-ui/themes';
import { ChevronDownIcon } from '@radix-ui/react-icons';
import { Member } from '../services/api';

interface StudentSwitcherProps {
    students: Member[];
    selectedStudent: Member | null;
    onStudentChange: (student: Member) => void;
    isDarkTheme: boolean;
}

const StudentSwitcher: React.FC<StudentSwitcherProps> = ({
    students,
    selectedStudent,
    onStudentChange,
    isDarkTheme
}) => {
    const [isOpen, setIsOpen] = useState(false);

    const handleStudentSelect = (memberId: string) => {
        const student = students.find(s => s.memberId.toString() === memberId);
        if (student) {
            onStudentChange(student);
        }
        setIsOpen(false);
    };

    if (!selectedStudent) {
        return null;
    }

    return (
        <div className="student-switcher">
            <Select.Root
                value={selectedStudent.memberId.toString()}
                onValueChange={handleStudentSelect}
                onOpenChange={setIsOpen}
            >
                <Select.Trigger className="student-trigger">
                    <Flex align="center" gap="2" className="trigger-content">
                        <Text size="2" weight="bold" className="student-name" truncate>
                            {selectedStudent.fullName}
                        </Text>
                    </Flex>
                </Select.Trigger>

                <Select.Content className="student-dropdown" position="popper" sideOffset={8}>
                    <Box className="dropdown-header">
                        <Text size="2" weight="bold" color="gray">
                            Switch Student ({students.length})
                        </Text>
                    </Box>
                    {students.map((student) => (
                        <Select.Item
                            key={student.memberId}
                            value={student.memberId.toString()}
                            className="student-option name-only"
                        >
                            <span className="student-list-name">{student.fullName}</span>
                        </Select.Item>
                    ))}
                </Select.Content>
            </Select.Root>
        </div>
    );
};

export default StudentSwitcher; 